<template>
  <div
    id="weezys"
    class="content"
  >
    <div>
      <div class="container">
        <h1 class="page-title">
          <i class="fal fa-robot"></i>
          {{ isAdmin ? "Weezys" :"Weezy" }}
        </h1>
        <div
          class="info-button"
          @click.stop="$parent.toggleInfo"
        >
          <i class="fal fa-info-circle"></i> {{$parent.info_visible ? "Masquer les informations" : "Voir les informations"}} </div>
      </div>
      <div
        class="page-description"
        :class="{hidden: !$parent.info_visible}"
      >
        <b-message type="is-primary">
          <i class="fal fa-info-circle"></i>
          Pour
          <strong>modifier</strong> les différentes entrées de la liste, sélectionnez un champ puis cliquez sur
          <strong>
            "
            <i class="far fa-check"></i> Valider les modifications
          </strong>.
          <br>Pour
          <strong>annuler</strong> les modifications, cliquez sur "
          <strong>
            <i class="far fa-times"></i> Annuler les modifications"
          </strong>.
          <br>Les Weezys sont automatiquement ajoutés lors de leur première connexion.
          <br>Ils ne peuvent ni être ajoutés, ni être supprimés.
        </b-message>
      </div>
    </div>
    <weezysTable
      id="weezysTable"
      :weezys="
                weezys"
      :campaigns="campaigns"
      :stripes="stripes"
      :supervisors="supervisors"
      :checkable="true"
      :isComponentModalActive="isComponentModalActive"
      :isAdmin="isAdmin"
    />
    <!-- </ul> -->
    <leaderBoard
      v-if="!isAdmin"
      id="leader-board"
      :users="users"
      :sales="sales"
    />
    <byTagSalesRepartition
      v-if="!isAdmin"
      id="leader-board"
      :users="users"
      :sales="sales"
      :campaigns="campaigns"
    />
  </div>
</template>

<script>
import weezysTable from "@/components/weezysTable";
import leaderBoard from "@/components/leaderBoard";
import byTagSalesRepartition from "@/components/byTagSalesRepartition";

import http from "@/modules/request";

export default {
  name: "weezys",
  components: {
    weezysTable,
    leaderBoard,
    byTagSalesRepartition
  },
  data() {
    return {
      isAddDisplayed: false,
      campaigns: [],
      supervisors: [],
      stripes: [],
      weezys: [],
      sales: [],
      users: [],
      weezyId: "",
      is_active: "",
      isComponentModalActive: false,
      isAdmin: false,
      creation: undefined
    };
  },
  beforeDestroy() {
    clearInterval(this.creation);
  },
  mounted() {
    this.getWeezys();
    this.getCampaigns();
    this.getSupervisors();
    this.getStripes();
    this.isAdmin = this.$store.state.role == "admin";
    if (!this.isAdmin) {
      this.getSales();
      this.getUsers();
      this.refreshData();
    } else {
      this.refreshWeezyStates();
    }
  },
  methods: {
    refreshData() {
      this.creation = setInterval(() => {
        this.getSales();
      }, 90000);
    },

    refreshWeezyStates() {
      this.creation = setInterval(() => {
        this.getWeezys();
      }, 90000);
    },

    getWeezys() {
      http
        .get("/weezys")
        .then(response => {
          for (let weezy of response.data) {
            weezy.password = "";
          }
          this.weezys = response.data;
        })
        .catch(error => {
          console.log(error);
          this.errored = true;
        });
    },
    getCampaigns() {
      http
        .get("/campaigns")
        .then(response => {
          this.campaigns = response.data;
        })
        .catch(error => {
          console.log(error);
          this.errored = true;
        });
    },
    getSupervisors() {
      http
        .get("/supervisors")
        .then(response => {
          this.supervisors = response.data;
        })
        .catch(error => {
          console.log(error);
          this.errored = true;
        });
    },
    getStripes() {
      http
        .get("/stripes")
        .then(response => {
          this.stripes = response.data;
        })
        .catch(error => {
          console.log(error);
          this.errored = true;
        });
    },
    getSales() {
      http
        .get("/sales")
        .then(response => {
          this.sales = response.data;
        })
        .catch(error => {
          console.log(error);
          this.errored = true;
        });
    },
    getUsers() {
      http
        .get("/privateusers")
        .then(response => {
          this.users = response.data;
        })
        .catch(error => {
          console.log(error);
          this.errored = true;
        });
    },

    rebootWeezy(weezy_id) {
      http
        .post("/weezys/" + weezy_id + "/reboot", {})
        .then(
          function(response) {
            this.getWeezys();
          }.bind(this)
        )
        .catch(function(error) {
          console.log("error (normal) :" + error);
          console.log("error (as JSON) :" + JSON.stringify(error));
        });
    },

    submitModify: function() {
      if (this.is_active && this.campaign_id == null) {
        this.warningToast(
          'Une Campagne est nécessaire pour activer le Weezy : "' +
            this.name +
            '"'
        );
        this.getWeezys();
      } else {
        http
          .patch("/weezys/" + this.weezyId, {
            weezy: {
              name: this.name,
              campaign_id: this.campaign_id,
              is_active: this.is_active,
              ip_address: this.ip_address,
              supervisor_id: this.supervisor_id,
              stripe_id: this.stripe_id,
              password: this.password
            }
          })
          .then(
            function(response) {
              this.succesToast("Weezy(s) modifié(s) avec succès");
              this.getWeezys();
            }.bind(this)
          )
          .catch(function(error) {
            this.errorToast("Échec de modification");
            this.getWeezys();
            console.log("error (normal) :" + error);
            console.log("error (as JSON) :" + JSON.stringify(error));
          });
      }
    },
    modifyRows(rows) {
      var count = rows.length;
      var modifiedArray = [];
      // From latest to oldest
      for (var i = 0; i < count; i++) {
        var modified = rows[count - i - 1];
        if (!modifiedArray.includes(modified.id)) {
          modifiedArray.push(modified.id);
          this.weezyId = modified.id;
          this.name = modified.name;
          this.campaign_id = modified.campaign_id;
          this.ip_address = modified.ip_address;
          this.is_active = modified.is_active;
          this.supervisor_id = modified.supervisor_id;
          this.stripe_id = modified.stripe_id;
          this.password = modified.password;
          this.submitModify();
        }
      }
    },
    errorToast(message) {
      this.$toast.open({
        duration: 5000,
        message: message,
        position: "is-bottom",
        type: "is-danger"
      });
    },
    succesToast(message) {
      this.$toast.open({
        duration: 2000,
        message: message,
        position: "is-bottom",
        type: "is-success"
      });
    },
    warningToast(message) {
      this.$toast.open({
        duration: 5000,
        message: message,
        position: "is-bottom",
        type: "is-warning"
      });
    }
  }
};
</script>

<style scoped>
.content {
  background-color: #ffffff;
}
.add-weezy {
  width: auto;
  padding-top: 40px;
  padding-left: 30px;
}
</style>